export function getRecentFiles(fileMap, numberOfFiles) {
    let filesArray = Object.values(fileMap)
    let tempFilesArray = filesArray.filter(each => !each.name.startsWith('dummy') && !each.isDir)
    tempFilesArray = tempFilesArray.sort(function compare(a, b) {
        return new Date(b.modDate) - new Date(a.modDate);
    });
    if (tempFilesArray.length > numberOfFiles) {
        tempFilesArray = tempFilesArray.slice(0, numberOfFiles)
    }
    return tempFilesArray;
}

export default getRecentFiles